/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reserve': {
    width: 28,
    height: 16,
    viewBox: '0 0 28 16',
    data: '<path pid="0" _fill="#008cff" d="M28 16H0V.02h.028L.025.017.061 0h5.128l-.046.02h16.281L21.412 0h3.495c.1.013.2.02.304.02H28zM25.812 2.143H2.187v11.735h23.625z"/><path pid="1" _fill="#008cff" d="M12.344 5H22v2h-9.656zM7 9h15v2H7z"/>'
  }
})
